import { green, grey } from '@mui/material/colors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import { BooleanStatusChipField, FunctionField } from 'shared/react-admin/Fields';
import { Company } from 'types/embedded/company';

type Props = {
  sourceId?: keyof Company;
};

export const CompanyShowDialogChipFields: React.FC<Props> = ({ sourceId = 'originId' }) => {
  const translate = useTypedTranslate();

  return (
    <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
      <FunctionField
        render={(record: Company) => <Chip label={`ID: ${record?.[sourceId]}`} size="small" />}
      />
      <FunctionField
        render={({ name }: Company) => (
          <Chip label={`${translate('app.table.name')}: ${name}`} size="small" />
        )}
      />
      <BooleanStatusChipField
        disabledColor={green[500]}
        disabledLabel={translate('app.companies.activeStatus')}
        enabledColor={grey[400]}
        enabledLabel={translate('app.statuses.archive')}
        source="archive"
      />
    </Stack>
  );
};
